import { Box, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../providers/auth'
import { FirstPartyPlatformType } from '../../types/Account'
import PlayStationIcon from '../icons/PlayStationIcon'
import XboxIcon from '../icons/XboxIcon'

/**
 * Returns the appropriate platform icon for the platform type.
 * @param platform {string} The platform type, e.g., 'XBOXLIVE', 'PLAYSTATIONNETWORK'.
 * @return {JSX.Element|null} The platform icon or null if the platform is not recognized.
 */
function getPlatformIcon(platform: FirstPartyPlatformType | ''): JSX.Element | null {
  switch (platform) {
    case FirstPartyPlatformType.XBOXLIVE:
      return <XboxIcon sx={{ width: 48, height: 48 }} sxSvg={{ fontSize: 28, color: 'white' }} />
    case FirstPartyPlatformType.PLAYSTATIONNETWORK:
      return (
        <PlayStationIcon sx={{ width: 48, height: 48 }} sxSvg={{ fontSize: 28, color: 'white' }} />
      )
    default:
      return null
  }
}

const PlatformDisplayName: FC = () => {
  const { authState } = useAuth()
  const { t } = useTranslation()
  const platform = authState?.accountInfo?.firstPartyPlatformType || ''
  const username = authState?.userInfo?.username || t('vpc:platformDisplayName.unknownGamertag')
  const suffix = authState?.userInfo?.suffix || ''

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      {getPlatformIcon(platform)}
      {username && (
        <Typography variant="body1" component="h2" sx={{ fontWeight: 'bold', ml: 1 }}>
          {username}
        </Typography>
      )}
      {suffix && platform == FirstPartyPlatformType.XBOXLIVE && (
        <Typography
          variant="body2"
          component="h2"
          sx={{
            fontSize: '0.875rem',
            fontWeight: 300,
            color: 'text.secondary',
            ml: 0.5,
          }}
        >
          #{suffix}
        </Typography>
      )}
    </Box>
  )
}

export default PlatformDisplayName
